import { yupResolver } from "@hookform/resolvers/yup";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";
import { startCase } from "lodash";
import { FormProvider, useForm } from "react-hook-form";
import { Text, View } from "react-native-ui-lib";
import {
  Form,
  SaveHeaderFormAware,
  Page,
} from "@towersystems/roam-common-native";
import { EditQuickKeyRootParamList } from "../../../../types";
import {
  itemToTypeListItem,
  PageItemType,
  quickKeyHasForm,
  useEditTile,
} from "../../../../utilities/layout";
import {
  actionNodeInputSchema,
  defaultLayoutNodeInputValues,
  LayoutNodeActionFormVariants,
} from "../../../../utilities/layout/constants";
import { normalizeSelectedValues } from "../../../../utilities/transforms";
import { LayoutNodeActionForm } from "../../components";
import {
  EditFilterDeleteFooter,
  EditTileFooter,
} from "../EditQuickKeyRootScreen/components";

export type EditActionQuickKeyScreenProps = NativeStackScreenProps<
  EditQuickKeyRootParamList,
  "EditActionQuickKeyScreen"
>;

export function EditActionQuickKeyScreen({
  navigation,
}: EditActionQuickKeyScreenProps) {
  const { item } = useEditTile();

  console.log("Editing action quick key:", item);

  if (!item) {
    return null;
  }

  const hasForm = item.config && quickKeyHasForm(item.config);

  return hasForm ? (
    <FormfulEdit {...{ item }} />
  ) : (
    <FormlessEdit {...{ item }} />
  );
}

type SubPageProps = {
  item: PageItemType;
};

function FormlessEdit({ item }: SubPageProps) {
  if (!item.config) return <></>;

  const typeListItem = itemToTypeListItem(item.config);

  const label = `Remove ${startCase(
    typeListItem.toLowerCase()
  )} quick key? This will remove the quick key from the register.`;

  return (
    <Page footer={<EditFilterDeleteFooter id={item.id} />}>
      <View>
        <Text
          style={{
            fontSize: 20,
          }}
        >
          {label}
        </Text>
      </View>
    </Page>
  );
}

function FormfulEdit({ item }: SubPageProps) {
  const { handleUpdateTile } = useEditTile();

  const methods = useForm<LayoutNodeInput>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizeSelectedValues(
      defaultLayoutNodeInputValues,
      item.config
    ),
    resolver: yupResolver(actionNodeInputSchema),
  });

  return (
    <Page footer={<EditTileFooter id={item.id} />}>
      <FormProvider {...methods}>
        <SaveHeaderFormAware onValidSubmit={handleUpdateTile} />
        <Form>
          <LayoutNodeActionForm variant={LayoutNodeActionFormVariants.Edit} />
        </Form>
      </FormProvider>
    </Page>
  );
}
